import type { Channel } from '@frontend/automatic-updates';

export const daysOfTheWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const ICON_BUTTON_WIDTH = 56;
export const TOP_BAR_HEIGHT = 72;
export const ICON_SIZE = 24;

/** TODO: probably be better to put these in the env or something */
type Channels = Record<string, readonly Channel[]>;

export const channels: Channels = {
  'app.getweave.com': [
    {
      label: 'Stable',
      slug: 'stable',
      value: 'app.getweave.com',
      description: 'Updates you receive will be less frequent.',
    } as const,
    {
      label: 'Edge',
      slug: 'edge',
      value: 'edge.getweave.com',
      description: 'More frequent updates and may include experimental features.',
    } as const,
  ],
  'app.weavedev.net': [
    {
      label: 'Stable',
      slug: 'stable',
      value: 'app.weavedev.net',
      description: 'Updates you receive will be less frequent.',
    } as const,
    {
      label: 'Edge',
      slug: 'edge',
      value: 'app-edge.weavedev.net',
      description: 'More frequent updates and may include experimental features.',
    } as const,
  ],
};

export const siteChannels = channels[window.location.hostname] as Channel[] | undefined;
